module.exports = __webpack_public_path__ + "fonts/Mastercard.78c80603a8a19d6e14e0b40bd95f7558.svg";